import { Box, Heading } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import Address from "components/Shared/Address";
import EmailLink from "components/Shared/EmailLink";
import { NA } from "components/Shared/EmptyPlaceholder";
import LabeledValue from "components/Shared/LabeledValue";
import LabeledValueGrid from "components/Shared/LabeledValueGrid";
import PhoneNumberLink from "components/Shared/PhoneNumberLink";

const fragment = gql(/* GraphQL */ `
  fragment BrandSettingsCompanyInformationContactViewSectionFields on BrandCompanyContact {
    id
    name
    email
    address {
      id
      ...AddressComponentFields
    }
    phoneNumber {
      id
      ...PhoneNumberLinkFields
    }
  }
`);

type Props = {
  title: string;
  isLoading?: boolean;
  contact: FragmentType<typeof fragment> | null | undefined;
};

export default function ContactViewSection({
  title,
  isLoading,
  contact: contactData,
}: Props) {
  const contact = getFragmentData(fragment, contactData);

  return (
    <Box p={4} borderWidth={1} borderColor="gray.200" borderRadius="lg">
      <Heading as="h3" size="sm" color="magenta.veryDark" mb={4}>
        {title}
      </Heading>

      <LabeledValueGrid isLoading={isLoading}>
        <LabeledValue label="Name" value={contact?.name} />

        <LabeledValue
          label="Email"
          value={<EmailLink email={contact?.email} />}
          isValuePresent={!!contact?.email}
        />

        <LabeledValue
          label="Phone"
          value={<PhoneNumberLink phoneNumber={contact?.phoneNumber} />}
          isValuePresent={!!contact?.phoneNumber}
        />

        <LabeledValue
          label="Address"
          value={<Address address={contact?.address} fallback={<NA />} />}
        />
      </LabeledValueGrid>
    </Box>
  );
}
